import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PictureComponent } from '../picture/picture.component';
import { Component, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { Picture } from '../picture';
import { PictureService } from '../picture.service';
import { SpringQuery } from '@app/_helpers/spring-query';
import { DevelopmentService } from '@app/_components/development';

@Component({
    selector: 'app-picture-list',
    templateUrl: './picture-list.component.html',
    styleUrls: ['./picture-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class PictureListComponent implements OnInit {
    developmentId: any;
    shortTermRentalId: any;
	developments: any;
	constructor(
		private pictureService: PictureService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private developmentService: DevelopmentService,
		private dialog: MatDialog,
	) {
		this.statuses = pictureService.statuses
	}



	// data
	pictures: any;
	picture: Picture;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number = 0;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'pictureId', header: 'Id', width: 'auto' },
		{ field: 'url', header: 'Picture', width: 'auto' },
		{ field: 'caption', header: 'Caption', width: 'auto' },
		{ field: 'createDate', header: 'Create Date', width: 'auto' },
		{ field: 'describesType', header: 'Describes Type', width: 'auto' },
		{ field: 'sortOrder', header: 'Sort Order', width: 'auto' },
		{ field: 'objectType', header: 'Object Type', width: 'auto' },
		{ field: 'objectName', header: 'Object Name', width: 'auto' },
	];

	validationMessages = {
		'name': [
			{ type: 'required', message: 'Required' }
		],
		'description': [
			{ type: 'required', message: 'Required' }
		],
	}

	ngOnInit(): void {
		this.fetchDevelopments()
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.pictureId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-picture-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}
			
			let springQuery = new SpringQuery();
			springQuery.addEquals('size', '200');
			if (this.developmentId) {
				springQuery.addEquals('developmentVO.developmentId', this.developmentId.toString())
			}
			if (this.shortTermRentalId) {
				springQuery.addEquals('shortTermRentalVO.shortTermRentalId', this.shortTermRentalId.toString())
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.pictureService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters,
				springQuery).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.pictures = res.data.pictures;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.recordTotal = this.recordTotal || 0;
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.pictures = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(picture: Picture) {
		try {
			this.formLoading = true;
			this.pictureService.update(picture)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.pictures.map((picture, i) => {
							if (picture.pictureId === res.data.picture.pictureId) {
								this.pictures[i] = res.data.picture;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(picture: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(picture));

			this.formLoading = true;
			this.pictureService.delete(picture.pictureId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.pictures.splice(this.pictures.indexOf(picture), 1);
						this.recordTotal = this.pictures.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Picture ' + picture.pictureId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'Picture ' + picture.pictureId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Picture'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PictureComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addPictureCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(picture: Picture) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			picture: picture,
			title: 'Edit Picture'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PictureComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updatePictureCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deletePictureCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addPictureCB(picture: Picture) {
		console.log('Adding Picture: ' + JSON.stringify(picture));
		// if we don't have a pictures array yet...
		if (!this.pictures) {
			this.pictures = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.pictures.unshift(picture);

		// no idea what this is but it is required to update the array
		this.pictures = [...this.pictures];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Picture ' + picture.pictureId + ' Added', life: 3000 });
	}

	updatePictureCB(picture: Picture) {
		console.log('Updating Picture: ' + JSON.stringify(picture));
		let itemIndex = this.pictures.findIndex((item: any) => item.pictureId === picture.pictureId);
		this.pictures[itemIndex] = picture;

		// no idea what this is but it is required to update the array
		this.pictures = [...this.pictures];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Picture ' + picture.pictureId + ' Updated', life: 3000 });
	}

	deletePictureCB(picture: Picture) {
		console.log('Removing Picture: ' + picture);
		this.pictures.splice(this.pictures.indexOf(picture), 1);
		this.recordTotal = this.pictures.length;

		// no idea what this is but it is required to update the array
		this.pictures = [...this.pictures];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Picture ' + picture.pictureId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.pictures ? this.first === (this.pictures.length - this.rows) : true; }
	isFirstPage(): boolean { return this.pictures ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(picture: any) {
		if (picture?.status) {
			const status = this.statuses.find((e: any) => e.value == picture.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}

	fetchDevelopments() {
			try {
				this.developmentService.findAll()
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.developments = res.data.developments;
							return this.developments;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}		
	}
}
